/**
 * 심볼 관련 타입 정의
 */
import { TRADINGVIEW_SYMBOL_INFO_LIST } from './tradingview';
/**
 * TradingViewSymbolInfo를 TradingSymbol로 변환하는 헬퍼 함수
 */
export function tradingViewSymbolInfoToTradingSymbol(symbolInfo) {
    return {
        symbol: symbolInfo.ticker,
        ticker: symbolInfo.ticker,
        description: symbolInfo.description,
        exchange: symbolInfo.exchange,
        type: symbolInfo.type,
    };
}
/**
 * 전체 심볼 목록
 * TRADINGVIEW_SYMBOL_INFO_LIST 기반으로 생성
 * symbol-categories.ts의 ALL_SYMBOL_CODES를 사용
 */
export const ALL_SYMBOLS = Object.values(TRADINGVIEW_SYMBOL_INFO_LIST).map(tradingViewSymbolInfoToTradingSymbol);
//# sourceMappingURL=symbol.js.map